exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1VI7sODJA-ppVyYLYH0954{display:flex;justify-content:center;align-items:center;background-color:#f7f7f7;height:14vh;width:100vw}\n", ""]);
// Exports
exports.locals = {
	"foot": "_1VI7sODJA-ppVyYLYH0954"
};